<template>

	<div>

		<!-- 리스트 -->
		<div class="list-content">

			<ul class="type-webzine">
				<li :id="'item-' + item.emIdx" v-for="(item, index) in courseList">
					<a href="javascript:;" @click="goDetail(item)">
						<div class="thumb-box" v-if="!$options.filters.isEmpty(item.thumbnail)" :style="'background-image: url(' + item.thumbnail + ');'"></div>
						<div v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);"></div>
						<div class="text-box">
							<div class="cate bedge-line">
								<span class="prim" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
								<span class="sec" >{{ item.shortTitle }}</span>
							</div>
							<h3 class="tit">
								{{ item.title }}
							</h3>
							<p class="desc">
								{{ item.comment }}
							</p>
							<ul class="thumb-list">

								<template v-for="(sitem, sidx) in item.eduMainList">
									<template v-if="sitem.thumbnail != null && sitem.thumbnail !== ''">
										<li v-if="sidx < 4" :style="'background-image: url(' + sitem.thumbnail + ');'"></li>
										<li v-if="sidx === 5" class="count"  :style="'background-image: url(' + sitem.thumbnail + ');'"><span>+{{ item.eduMainList.length - 5 }}</span></li>
									</template>
									<template v-else>
										<li v-if="sidx < 4" style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);"></li>
										<li v-if="sidx === 5" class="count" style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);"><span>+{{ item.eduMainList.length - 5 }}</span></li>
									</template>
								</template>

<!--								<li style="background-image: url(../../assets/img/temp/temp_img_01.png);"></li>
								<li style="background-image: url(../../assets/img/temp/temp_img_02.png);"></li>
								<li style="background-image: url(../../assets/img/temp/temp_img_03.png);"></li>
								<li style="background-image: url(../../assets/img/temp/temp_img_04.png);"></li>
								<li style="background-image: url(../../assets/img/temp/temp_img_05.png);"></li>
								<li class="count" style="background-image: url(../../assets/img/temp/temp_img_05.png);"><span>+5</span></li>-->
							</ul>
						</div>
					</a>
				</li>
			</ul>


		</div>

	</div>

</template>

<script>

export default {
	name: "courseList",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		courseList: Array,
	},
	data() {



		return {
			//eduList: [],
			eduCount: 0,
		}
	},
	created() {

	},
	mounted() {
	},
	methods: {


		goDetail( _item ) {
			if (this.$route.path.indexOf("searcher") > -1) {
				this.webUtils.goTo(this, `/app/education/course/${_item.cateCode.slice(0, 6)}?mode=detail&cidx=${_item.cidx}`, true)
			}
			console.log( this.forApp )
			if ( this.forApp ) {
				this.goAppEducation(_item.cateCode, _item.cidx)
			}
			this.$eventBus.$emit("goDetail", _item.cidx)
		},

	},
}
</script>

<style scoped>

</style>
